import { useEffect } from 'react';
import { TextField } from '@recargas-dominicanas/core/components';
import { useForm } from '../../../utils/useForm';
import { Modal } from '../../../components/modal/modal.component';
import { useSalesStore } from '../../../stores/salesStore';
import { style } from './add-balance-modal.module.css';

interface Props {
  open: boolean;
  onSave: (balance: number) => void;
  onClose: () => void;
}

export function AddBalanceModal(props: Props) {

  const { open, onSave, onClose } = props;

  const salesStore = useSalesStore();
  
  const form = useForm({
    balance: '',
  }, [open]);

  useEffect(() => {

    form.balance.removeValidator('min');
    form.balance.removeValidator('max');
    form.balance.removeValidator('int');

    form.balance.addValidator({
      key: 'min' as any,
      error: 'El valor debe ser mayor a 0', 
      validate: (value) => parseInt(value as string) > 0
    });
    
    form.balance.addValidator({
      key: 'max' as any,
      error: 'El valor no puede ser mayor a tu balance actual', 
      validate: (value) => parseInt(value as string) < salesStore.balance
    });

    form.balance.addValidator({
      key: 'int' as any,
      error: 'El valor debe ser un número entero',
      validate: (value) => Number.isInteger(parseFloat(value as string))
    });
  }, [open]);

  async function handleSave() {
    if (form.validate()) {
      onSave(parseInt(form.balance.value));
    }
  }

  function handleClose() {
    form.clear();
    onClose();
  }

  return (
    <Modal
      open={open}
      title='Asignar balance'
      style={style.modal}
      secondaryButton='Asignar'
      onClose={handleClose}
      onSecondaryClick={handleSave}>
      <TextField 
        style={style.textField}
        label='Balance'
        type='number'
        value={form.balance.value}
        error={form.balance.error}
        onChange={form.balance.onChange}
        onBlur={form.balance.onBlur}/>
    </Modal>
  );
}
